import { useLocalization } from 'common/providers/LocaleProvider';

export interface UseWarningMessageParams {
  sellableAfterUpdate: boolean;
  otherVariantAvailable: boolean;
}

export const useWarningMessage = (params: UseWarningMessageParams) => {
  const { t } = useLocalization();

  if (!params.sellableAfterUpdate) {
    return t('h24_item_not_sellable');
  }

  return params.otherVariantAvailable
    ? t('h24_variant_not_available')
    : t('h24_product_not_available');
};
